import FamilyRecordsModule from '../components/FamilyRecordsModule'

export default function Finance(){
 return <FamilyRecordsModule module="transactions"/>
}
